import React from "react";

const UserSecurityHeader = () => {

    return (

        <div
            className="card text-white mb-3"
            style={{
                background:
                    "linear-gradient(90deg,#2F80ED,#4F8EF7)"
            }}
        >

            <div className="card-body">

                <div className="d-flex justify-content-between align-items-center">

                    <div>

                        <h3 className="mb-1">

                            User Permission Overrides

                        </h3>

                        <small>

                            Manage user-specific permissions, overrides and password security

                        </small>

                    </div>

                    <button className="btn btn-light">

                        Refresh

                    </button>

                </div>

            </div>

        </div>

    );

};

export default UserSecurityHeader;